var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-box"},[_c('div',{staticClass:"heading"},[_c('BaseIcon',{attrs:{"icon":"info-circle","size":"20"}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("i18n")("noAccess.title")))])],1),_c('div',[_vm._v(" "+_vm._s(_vm._f("i18n")("noAccess.desc"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }